import React, { useEffect } from 'react';
import { FiCheckCircle } from 'react-icons/fi';
import styles from './Toast.module.css';

interface ToastProps {
  message: string;
  onClose: () => void;
  duration?: number;
}

const Toast: React.FC<ToastProps> = ({ message, onClose, duration = 3000 }) => {
  useEffect(() => {
    const timer = setTimeout(() => {
      onClose();
    }, duration);

    return () => clearTimeout(timer);
  }, [duration, onClose]);

  return (
    <div 
      className={`fixed top-4 right-4 z-[9999] bg-green-50 text-green-800 px-6 py-3 rounded-lg shadow-lg flex items-center gap-2 min-w-[300px] max-w-[500px] border border-green-200 ${styles['animate-slide-in']}`}
      role="alert"
    >
      <FiCheckCircle className="text-xl text-green-600" />
      <span className="flex-1">{message}</span>
      <button
        onClick={onClose}
        className="text-green-600 hover:text-green-700 focus:outline-none"
        aria-label="Close toast"
      >
        ×
      </button>
    </div>
  );
};

export default Toast; 